module.exports = __webpack_public_path__ + "static/media/CVS-HS-SPM-Reflect-02-01.b24fe7bd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/CVS-HS-SPM-Reflect-02-01.mp3
// module id = 596
// module chunks = 0